// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-before-login[data-v-20228be4]{width:100vw;height:100vh;justify-content:center;align-items:center;flex-direction:row;display:flex}", ""]);
// Exports
module.exports = exports;
